<div class="content" [ngClass]="{ showBack: flip }">
    <div class="front">
        <svg-playing-card
            [ngClass]="(cardStyle$ | async).value"
            *ngIf="cardId !== 'XX'"
            [hidden]="cardId === 'XX' && !isClient && !communityCards"
            [cardId]="cardId"
            [id]="cardId"
            [rabbitCard]="rabbitCard"
            (click)="submitFoldToShow(cardId)"
        ></svg-playing-card>
        <svg
            *ngIf="toggledCard && isClient"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            width="10px"
            height="10px"
            viewBox="0 0 561 561"
            style="enable-background: new 0 0 561 561; position: absolute; top: 48px; left: 5px;"
            xml:space="preserve"
        >
            <g>
                <g id="visibility">
                    <path
                        d="M280.5,89.25C153,89.25,43.35,168.3,0,280.5c43.35,112.2,153,191.25,280.5,191.25S517.65,392.7,561,280.5    C517.65,168.3,408,89.25,280.5,89.25z M280.5,408C209.1,408,153,351.9,153,280.5c0-71.4,56.1-127.5,127.5-127.5    c71.4,0,127.5,56.1,127.5,127.5C408,351.9,351.9,408,280.5,408z M280.5,204c-43.35,0-76.5,33.15-76.5,76.5    c0,43.35,33.15,76.5,76.5,76.5c43.35,0,76.5-33.15,76.5-76.5C357,237.15,323.85,204,280.5,204z"
                    />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
        <svg
            *ngIf="isRevealed === true"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_2"
            x="0px"
            y="0px"
            width="10px"
            height="10px"
            viewBox="0 0 561 561"
            style="enable-background: new 0 0 561 561; position: absolute; top: 38px; left: 5px;"
            xml:space="preserve"
        >
            <g>
                <g id="visibility">
                    <path
                        d="M280.5,89.25C153,89.25,43.35,168.3,0,280.5c43.35,112.2,153,191.25,280.5,191.25S517.65,392.7,561,280.5    C517.65,168.3,408,89.25,280.5,89.25z M280.5,408C209.1,408,153,351.9,153,280.5c0-71.4,56.1-127.5,127.5-127.5    c71.4,0,127.5,56.1,127.5,127.5C408,351.9,351.9,408,280.5,408z M280.5,204c-43.35,0-76.5,33.15-76.5,76.5    c0,43.35,33.15,76.5,76.5,76.5c43.35,0,76.5-33.15,76.5-76.5C357,237.15,323.85,204,280.5,204z"
                    />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    </div>
    @if (!rabbitCard) {
        <div
            *ngIf="communityCards ?? cardId === 'XX'"
            [hidden]="communityCards ? false : timeToShow"
            [ngClass]="{'back': communityCards === true , 'wrapper': !communityCards}">
            <img [src]="getCardSrc('XX')" />
        </div>
    } 

    <!-- To add flip animation to rabbit cards uncomment this @else -->

    <!-- @else {
        <div class="back">
            <svg-playing-card
                [cardId]="''"
                [rabbitCardBack]="true"
            >
            </svg-playing-card>
        </div>
    } -->
</div>
